import { render } from "./coupon_info.vue?vue&type=template&id=1d257c0a&ts=true"
import script from "./coupon_info.vue?vue&type=script&lang=ts"
export * from "./coupon_info.vue?vue&type=script&lang=ts"

import "./coupon_info.vue?vue&type=style&index=0&id=1d257c0a&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__